"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.withMedia = exports.queries = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _reactMedia = _interopRequireDefault(require("@kupibilet/react-media"));

var queries = {
  isMobile: 'screen and (max-width: 599px)',
  isTablet: 'screen and (min-width: 600px) and (max-width: 1199px)',
  isHandheld: 'screen and (max-width: 1199px)',
  isDesktop: 'screen and (min-width: 1200px)'
  /**
   * @usage
   * const Component = ({ isMobile, isTablet, isHandheld, isDesktop }) => {}
   * export default withMedia(Component)
   */

};
exports.queries = queries;

var withMedia = function withMedia(Component) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2["default"])(_class, _React$Component);

    function _class() {
      var _getPrototypeOf2;

      var _this;

      (0, _classCallCheck2["default"])(this, _class);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(_class)).call.apply(_getPrototypeOf2, [this].concat(args)));
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderMedias", function (medias) {
        return _react["default"].createElement(Component, (0, _extends2["default"])({}, _this.props, medias));
      });
      return _this;
    }

    (0, _createClass2["default"])(_class, [{
      key: "render",
      value: function render() {
        return _react["default"].createElement(_reactMedia["default"], {
          queries: queries
        }, this.renderMedias);
      }
    }]);
    return _class;
  }(_react["default"].Component), (0, _defineProperty2["default"])(_class, "displayName", 'withMedia'), _temp;
};

exports.withMedia = withMedia;
var media = {
  mobile: function mobile() {
    return (0, _styledComponents.css)([".responsive &,.responsive-booking &{@media ", "{", "}}"], queries.isMobile, _styledComponents.css.apply(void 0, arguments));
  },
  tablet: function tablet() {
    return (0, _styledComponents.css)([".responsive &,.responsive-booking &{@media ", "{", "}}"], queries.isTablet, _styledComponents.css.apply(void 0, arguments));
  },
  handheld: function handheld() {
    return (0, _styledComponents.css)([".responsive &,.responsive-booking &{@media ", "{", "}}"], queries.isHandheld, _styledComponents.css.apply(void 0, arguments));
  },
  desktop: function desktop() {
    return (0, _styledComponents.css)([".responsive &,.responsive-booking &{@media ", "{", "}}"], queries.isDesktop, _styledComponents.css.apply(void 0, arguments));
  }
};
var _default = media;
exports["default"] = _default;